import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'
import React, { StrictMode, Suspense, useEffect } from 'react'
import { Html, useProgress } from '@react-three/drei'
import { KeyboardControls } from '@react-three/drei'
import Interface from './Interface.jsx'

function Loader() {
    const { active, progress, errors, item, loaded, total } = useProgress()

    useEffect(() => {
        console.log(active, progress + '%', loaded)
    }, [active, progress])

    return <Html> <h3>🌀 Loading ...{progress} % loaded</h3></Html>;
}

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
    <StrictMode>
        <KeyboardControls
            map={[
                { name: 'forward', keys: ['ArrowUp', 'KeyW'] },
                { name: 'backward', keys: ['ArrowDown', 'KeyS'] },
                { name: 'leftward', keys: ['ArrowLeft', 'KeyA'] },
                { name: 'rightward', keys: ['ArrowRight', 'KeyD'] },
                { name: 'jump', keys: ['Space'] },
            ]}
        >
            <Canvas orthographic shadows camera={{ left: -5, top: 5, bottom: 5, zoom: 50, position: [0, 0, 10]}}
            
            // camera={{
            //     isOrthographicCamera: true
            >
                <Suspense fallback={<Loader />}>
                    <Experience />
                </Suspense>
            </Canvas>
            <Interface />
        </KeyboardControls>
    </StrictMode>
)